export default __webpack_public_path__ + "static/media/category-bg2.65aebe31.png";